import type { FragmentData } from "@gqlb/core";
import type React from "react";
import { type HEADER_FRAGMENT, Header } from "./Header";
import { Footer } from "./layout/Footer";

const BANNER = (
  <>
    Join our VIP program for just $0.99 (SAVE $79). Use code <b>VIP99</b> or click{" "}
    <a
      href="/menu?coupon=VIP99"
      className="underline font-bold hover:text-brand-black transition-colors"
    >
      here
    </a>{" "}
    to take advantage of this offer!
  </>
);

export const PageLayout: React.FC<
  React.PropsWithChildren<{
    data: FragmentData<typeof HEADER_FRAGMENT>;
    noPadding?: boolean;
    overlayHeader?: boolean;
  }>
> = ({ children, data, noPadding, overlayHeader }) => {
  return (
    <>
      <Header data={data} banner={BANNER} overlay={overlayHeader} />
      <main className={`min-h-[80vh] ${noPadding ? "" : "pt-4 lg:pt-12"}`}>{children}</main>
      <Footer />
    </>
  );
};
